import React, { useContext } from "react"
import UAI from "../UAI"
import { UsuarioContext } from "../Context/Usuario"
import "./NombreCohorte.css"

const NombreCohorte = (props) => {
  const { usuario } = useContext(UsuarioContext)

  let nombre =
    props.cohorte.facultad_id === 13 && usuario.periodo < 2022
      ? UAI.nombresGrados[props.cohorte.gradoid] + " " + props.cohorte.nombre
      : props.cohorte.nombre
  if (props.incluirId) {
    nombre = nombre + " " + props.cohorte.id
  }
  return (
    <div
      id={"cohorte-" + props.cohorte.id}
      className="nombre-cohorte link"
      onClick={() => {
        if (props.onClick) {
          props.onClick(props.cohorte.id)
        }
      }}
    >
      <span className="d-sm-none">
        {props.cohorte.sigla_interna}
        {props.cohorte.sigla}
      </span>
      <span className="d-none d-sm-block">{nombre}</span>
    </div>
  )
}

export default NombreCohorte
